import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const EditAddress = (props) => {
  const [loading, setLoading] = useState(true);
  const [street, setStreet] = useState(
    props.address ? props.address.street : ""
  );
  const [number, setNumber] = useState(
    props.address ? props.address.number : ""
  );
  const [postCode, setPostCode] = useState(
    props.address ? props.address.postCode : ""
  );
  const [city, setCity] = useState(props.address ? props.address.city : "");

  const getData = () => {
    setLoading(true);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const editAddress = async (e) => {
    if (validateAddress()) {
      setLoading(true);

      var address = {
        street: street,
        number: number,
        postCode: postCode,
        city: city,
      };

      var body = {
        id: props.id,
        table: props.table,
        address: JSON.stringify(address),
      };

      fetch("https://apidevkppp.ftpeople.pl/updateAddress", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then((data) => {
          MySwal.fire({
            icon: "success",
            title: "Edytowano",
            text: "adres",
          }).then(async (result) => {
            props.close();
          });
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validateAddress = (e) => {
    if (
      street.length > 0 &&
      number.length > 0 &&
      postCode.length > 0 &&
      city.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div style={{ width: "40vw" }} className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Ulica <span className="requiredStar">*</span>
              </label>
              <input
                style={{ boxSizing: "border-box" }}
                type="text"
                value={street}
                onChange={(e) => {
                  setStreet(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Numer <span className="requiredStar">*</span>
              </label>
              <input
                style={{ boxSizing: "border-box" }}
                type="text"
                value={number}
                onChange={(e) => {
                  setNumber(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Kod pocztowy <span className="requiredStar">*</span>
              </label>
              <input
                style={{ boxSizing: "border-box" }}
                type="text"
                value={postCode}
                onChange={(e) => {
                  setPostCode(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Miejscowość <span className="requiredStar">*</span>
              </label>
              <input
                style={{ boxSizing: "border-box" }}
                type="text"
                value={city}
                onChange={(e) => {
                  setCity(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editAddress}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditAddress;
